import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserExternalConnectionInterface } from "../../../middleware/interfaces/user/user-external-connection-interface";

export const UserExternalConnection = {
  Create: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const userExternalConnectionData: UserExternalConnectionInterface =
        state.data;
      const url = "./php/user/user-external-connector-proxy.php";
      await axios
        .post(url, userExternalConnectionData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = "SOMETHING WENT WRONG! PLEASE CONTACT ADMIN.";
    }

    return serverResponse;
  },
};
